import useTheme from "./useTheme";
import { getPropName } from "./useResponsiveProp";
import { hasOwnProperty } from "../utils/core";

function useAllResponsiveProps(props, propName) {
  var theme = useTheme();
  var breakpoints = Object.keys(theme.breakpoints);
  var result = {};

  if (hasOwnProperty(props, propName)) {
    result[propName] = props[propName];
  }

  breakpoints.forEach(function (bp) {
    var prop = getPropName(propName, bp);

    if (hasOwnProperty(props, prop)) {
      result[prop] = props[prop];
    }
  });
  return result;
}

export default useAllResponsiveProps;